import { Card } from "react-bootstrap";
import { IPageView } from "../types";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import { IoArrowBackOutline } from "react-icons/io5";

export interface ViewPageProps {
  viewPage: IPageView | null;
  setViewPage: (value: IPageView | null) => void;
}

export const SeoWebsiteAuditView: React.FC<ViewPageProps> = ({
  viewPage,
  setViewPage,
}) => {
  const gradientId = "progressGradient1";
  return (
    <Card
      className="p-0 mt-3"
      style={{
        maxWidth: "100%",
        boxShadow:
          "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.3rem",
          cursor: "pointer",
        }}
        className="px-4 pt-3"
        onClick={() => setViewPage(null)}
      >
        {" "}
        <IoArrowBackOutline />
        {"Back"}
      </div>
      <div
        className="px-4 pt-3"
        style={{ display: "flex", alignItems: "center", gap: "1rem" }}
      >
        <div>Overview</div>
        <div style={{ marginLeft: "auto" }}>3 days ago</div>
      </div>
      <hr className="my-3" />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "2rem",
        }}
        className="px-4"
      >
        <div style={{ width: 150, height: 150, marginBottom: "3rem" }}>
          <svg style={{ height: 0 }}>
            <defs>
              <linearGradient id={gradientId} gradientTransform="rotate(90)">
                <stop offset="0%" stopColor="#00FF00" />
                <stop offset="50%" stopColor="#FFD700" />
                <stop offset="100%" stopColor="#FF4500" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div style={{ width: "100%" }}>
          <div
            style={{
              fontWeight: 600,
              fontSize: "25px",
            }}
          >
            {"22plasticsurgery.com"}
          </div>
          <div
            style={{
              marginBottom: "0.3rem",
              fontWeight: 400,
              fontSize: "18px",
              lineHeight: "15px",
            }}
          >
            {viewPage?.title || ""}
          </div>
          <div
            style={{
              fontSize: "15px",
              color: "#797878",
              fontWeight: 500,
              marginBottom: "0.2rem",
            }}
          >
            {viewPage?.description || ""}
          </div>
          <a
            href={String(viewPage?.link || "")}
            target="_blank"
            rel="noopener noreferrer"
            className="linkTable"
          >
            {viewPage?.link || ""}
          </a>
        </div>
      </div>
    </Card>
  );
};
